import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@descope/react-sdk";
import { useEffect } from "react";
import { LoginScreen } from "../components/auth/login-screen";

interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: (search.redirect as string) || undefined,
    };
  },
  component: LoginRoute,
});

function LoginRoute() {
  const { isAuthenticated, isSessionLoading } = useSession();
  const search = Route.useSearch();
  const navigate = useNavigate();

  // Handle redirect after authentication
  useEffect(() => {
    if (isAuthenticated && !isSessionLoading) {
      const redirectPath = search.redirect ?? "/";
      void navigate({ to: redirectPath });
    }
  }, [isAuthenticated, isSessionLoading, search.redirect, navigate]);

  // Show loading while checking session
  if (isSessionLoading) {
    return (
      <div className="bg-background flex min-h-screen items-center justify-center">
        <div className="border-primary h-12 w-12 animate-spin rounded-full border-b-2"></div>
      </div>
    );
  }

  // If already authenticated, show redirecting state
  if (isAuthenticated) {
    return (
      <div className="bg-background flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="border-primary mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2"></div>
          <p className="text-muted-foreground">Redirecting...</p>
        </div>
      </div>
    );
  }

  return <LoginScreen />;
}
